export default class AccessRight {
    constructor (dto) {
        this.id = 0;
        this.name = '';
        this.objectCreate = false;
        this.objectRead = false;
        this.objectUpdate = false;
        this.objectDelete = false;
        this.objectDownload = false;
        this.objectPrint = false;
        this.objectSign = false;
        this.objectExternalDistribution = false;
        this.documentAttachmentCreate = false;
        this.documentAttachmentDelete = false;
        this.documentAttachmentRead = false;
        this.documentAttachmentUpdate = false;
        this.documentAttachmentDownload = false;
        this.commentCreate = false;
        this.commentRead = false;
        this.commentUpdate = false;
        this.commentDelete = false;
        this.dynamicTablesAddData = false;

        if (dto) {
            this.id = dto.id;
            this.name = dto.name;
            this.objectCreate = dto.objectCreate;
            this.objectRead = dto.objectRead;
            this.objectUpdate = dto.objectUpdate;
            this.objectDelete = dto.objectDelete;
            this.objectDownload = dto.objectDownload;
            this.objectPrint = dto.objectPrint;
            this.objectSign = dto.objectSign;
            this.objectExternalDistribution = dto.objectExternalDistribution;
            this.documentAttachmentCreate = dto.documentAttachmentCreate;
            this.documentAttachmentDelete = dto.documentAttachmentDelete;
            this.documentAttachmentRead = dto.documentAttachmentRead;
            this.documentAttachmentUpdate = dto.documentAttachmentUpdate;
            this.documentAttachmentDownload = dto.documentAttachmentDownload;
            this.commentCreate = dto.commentCreate;
            this.commentRead = dto.commentRead;
            this.commentUpdate = dto.commentUpdate;
            this.commentDelete = dto.commentDelete;
            this.dynamicTablesAddData = dto.dynamicTablesAddData;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            ObjectCreate: this.objectCreate,
            ObjectRead: this.objectRead,
            ObjectUpdate: this.objectUpdate,
            ObjectDelete: this.objectDelete,
            ObjectDownload: this.objectDownload,
            ObjectPrint: this.objectPrint,
            ObjectSign: this.objectSign,
            ObjectExternalDistribution: this.objectExternalDistribution,
            DocumentAttachmentCreate: this.documentAttachmentCreate,
            DocumentAttachmentDelete: this.documentAttachmentDelete,
            DocumentAttachmentRead: this.documentAttachmentRead,
            DocumentAttachmentUpdate: this.documentAttachmentUpdate,
            DocumentAttachmentDownload: this.documentAttachmentDownload,
            CommentCreate: this.commentCreate,
            CommentRead: this.commentRead,
            CommentUpdate: this.commentUpdate,
            CommentDelete: this.commentDelete,
            DynamicTablesAddData: this.dynamicTablesAddData,
        };
    }
}
